import { CURRENT_USER } from "constants/storageKeys";

export type PendingSignupUser = {
  profileId: string;
  email: string;
  firstName: string;
  lastName: string;
  mobile: string;
  isMobileVerified: boolean;
};

export const readPendingSignupUser = (): PendingSignupUser | null => {
  try {
    const stored = localStorage.getItem(CURRENT_USER);
    if (!stored) return null;

    const user = JSON.parse(stored);
    if (!user?.uuid) return null;

    return {
      profileId: user.uuid,
      email: user.email ?? "",
      firstName: user.first_name ?? "",
      lastName: user.last_name ?? "",
      mobile: user.mobile ?? "",
      isMobileVerified: Boolean(user.is_mobile_verified),
    };
  } catch {
    return null;
  }
};
